import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { TOAST } from 'constant';
import { toast } from 'layout';
import PropTypes from 'prop-types';
import { mapError } from 'utils/func';

const Confirm = forwardRef(({ refetch, setParentVisible }, ref) => {
  // #region Data
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);
  const [midtermReportControl, setMidtermReportControl] = useState(null);
  const { mutate, value } = useMemo(
    () => ({
      mutate: midtermReportControl?.mutate ?? null,
      value: midtermReportControl?.councilData ?? { id: null },
    }),
    [midtermReportControl]
  );
  // #endregion

  // #region Event
  useImperativeHandle(
    ref,
    () => ({
      open: (_midtermReportControl) => {
        setMidtermReportControl({ ..._midtermReportControl });
        setVisible(true);
      },
    }),
    []
  );

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('projectProposal.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('projectProposal.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          if (!value?.id) return;
          mutate(value.id, {
            onSuccess: () => {
              toast(TOAST.SUCCESS, t('project.viewList.midtermDocumentDialog.delete.success'));
              setVisible(false);
              refetch();
              if (setParentVisible) setParentVisible(false);
            },
            onError: (error) => {
              toast(TOAST.ERROR, mapError(t, error));
            },
          });
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={
        <p className="text-red-500">{t('project.viewList.midtermDocumentDialog.delete.title')}</p>
      }
      visible={visible}
      position="center"
      style={{ width: '450px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg">
        <span className="font-bold">
          {t('project.viewList.midtermDocumentDialog.delete.label')}:
        </span>{' '}
        {t('project.viewList.midtermDocumentDialog.versionText')} {value?.version}
      </p>
      <p className="text-lg">
        {t('project.viewList.midtermDocumentDialog.delete.confirmationMessage')}
      </p>
    </Dialog>
  );
});

export default Confirm;

Confirm.propTypes = {
  refetch: PropTypes.func,
  setParentVisible: PropTypes.func,
};

Confirm.defaultProps = {
  refetch: () => null,
  setParentVisible: () => null,
};
